import Badge from './Badge';
import Ribbon from './Ribbon';

export { Ribbon, Badge as ShieldBadge };
